/**
 * Smooth-scroll main-menu hash links to their targets,
 * accounting for the fixed navbar and closing the mobile overlay.
 */
const scrollToId = (() => {
	const MENU_SELECTOR = "#block-cassini-ed-main-menu";
	const NAVBAR_SELECTOR = ".site-navbar";
	const LINK_SELECTOR = "a.nav-link";
	const mobileMql = window.matchMedia("(max-width: 991px)");

	const getNavbarOffset = () => {
		const navbar = document.querySelector(NAVBAR_SELECTOR);
		return navbar ? navbar.getBoundingClientRect().bottom : 0;
	};

	const closeMobileMenu = () => {
		if (!mobileMql.matches) {
			return;
		}

		document.body.classList.remove("menu-open");
		document.querySelector(".hamburger")?.classList.remove("is-active");
	};

	const scrollToTarget = (target) => {
		const top =
			window.scrollY + target.getBoundingClientRect().top - getNavbarOffset();

		window.scrollTo({
			top: Math.max(0, top),
			behavior: "smooth",
		});
	};

	const onClick = (event) => {
		const link = event.target.closest(LINK_SELECTOR);

		if (!link) {
			return;
		}

		const href = link.getAttribute("href");

		if (!href || !href.startsWith("#") || href === "#") {
			return;
		}

		const target = document.getElementById(href.slice(1));

		if (!target) {
			return;
		}

		event.preventDefault();
		closeMobileMenu();
		scrollToTarget(target);
		history.pushState(null, "", href);
	};

	const init = () => {
		const menu = document.querySelector(MENU_SELECTOR);

		if (!menu) {
			return;
		}

		menu.addEventListener("click", onClick);
	};

	return {
		init,
	};
})();

export default scrollToId;
